/* eslint-disable local-rules/set-state-in-use-effect */
import {doAsync} from '@aboutyou/utils';
import {useCallback, useEffect} from 'react';
import {useSessionId} from './sessionStore/session.hooks';
import {
  TADARIDA_LOGOUT_BROADCAST_KEY,
  TADARIDA_SESSION_PERSIST_KEY,
  TADARIDA_USER_PERSIST_KEY,
} from './userStore/constants';
import {useUser} from './userStore/user.hooks';

export const BroadcastUserDataToTabs = {
  bc: (() => {
    if (typeof BroadcastChannel === 'undefined') {
      return null;
    }
    return new BroadcastChannel('USER_DATA_BROADCAST');
  })(),

  broadcastData: ({key, data}: {key: string; data?: object | null}) => {
    if (BroadcastUserDataToTabs.bc) {
      BroadcastUserDataToTabs.bc.postMessage({
        key,
        data,
      });
    }
  },
};

export const SyncSessionBetweenTabs = () => {
  const {data: sessionData, updateCache: updateSessionCache} = useSessionId();
  const {data: user, updateCache: updateUserCache} = useUser();

  const handleBroadcast = useCallback(
    (message: MessageEvent) => {
      const key = message.data.key;
      const data = message.data.data;

      switch (key) {
        case TADARIDA_SESSION_PERSIST_KEY: {
          if (data && data?.sessionId !== sessionData?.sessionId) {
            updateSessionCache(data);
          }
          break;
        }
        case TADARIDA_USER_PERSIST_KEY: {
          if (JSON.stringify(data) !== JSON.stringify(user)) {
            updateUserCache(data);
          }
          break;
        }
        case TADARIDA_LOGOUT_BROADCAST_KEY: {
          doAsync(() => {
            window.location.reload();
          });
          break;
        }
        default:
          break;
      }
    },
    [sessionData?.sessionId, updateSessionCache, updateUserCache, user],
  );

  useEffect(() => {
    if (!BroadcastUserDataToTabs.bc) {
      return;
    }

    BroadcastUserDataToTabs.bc.onmessage = message => {
      requestAnimationFrame(() => handleBroadcast(message));
    };
  }, [handleBroadcast]);

  return null;
};
